module.exports = __webpack_public_path__ + "static/media/62.27cb7f7e.jpg";